import { Box, Stack, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { Button, Input, Modal } from 'uikit'
import { useResetPassword } from './useResetPassword'

export const Password = ({ id }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [value, setValue] = useState('')
  const { mutate: request, isPending: isLoading } = useResetPassword(id)

  const handleForm = () => {
    const payload = {
      type: 'password',
      temporary: false,
      value,
    }
    request(payload, {
      onSuccess: () => {
        setValue('')
        setIsOpen(false)
      },
    })
  }

  return (
    <>
      <Stack gap={2}>
        <Text>Для нового пользователя необходимо вручную установить пароль</Text>
        <Box>
          <Button colorPalette="gray" loading={isLoading} onClick={() => setIsOpen(true)} size="sm">
            Изменить пароль
          </Button>
        </Box>
      </Stack>
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title="Изменение пароля"
        footer={
          <Button colorPalette="orange" loading={isLoading} onClick={handleForm}>
            Изменить
          </Button>
        }
      >
        <Input
          autoFocus
          type="password"
          name="value"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          label="Пароль"
          disabled={isLoading}
        />
      </Modal>
    </>
  )
}
